import axios, { type Method } from 'axios';
import type { AxiosRequestConfig } from 'axios';

// const BASE_API_MEFOOD_URL = 'http://localhost:3220';//import.meta.env.VITE_DATA_URL;
const BASE_API_MEFOOD_URL = import.meta.env.VITE_DATA_URL;
const TOKEN_MEYO_API = import.meta.env.VITE_MEFOOD_API_TOKEN;
const MEFOOD_TOKEN = import.meta.env.VITE_MEFOOD_TOKEN;
export const API_TIMEOUT = 70000;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': import.meta.env.VITE_API_ORBBYTE_KEY
};

let tokenCache: Record<string, string> = {};

async function fetchFirebaseToken(uid: string): Promise<string> {
    try {
        const response = await axios.get(`${BASE_API_MEFOOD_URL}/user/get/firebase/token/${uid}`, { headers: headers });
        const token = response.data.token;
        sessionStorage.setItem(`token-${uid}`, token);
        console.log('Fetched Firebase token:', token);
        return token;
    } catch (error) {
        console.error('Failed to fetch Firebase token:', error);
        throw error;
    }
}


async function getHeaders(uid?: string): Promise<Record<string, string>> {
    // console.log('getHeaders', uid);
    if (!uid) {

        return {
            Authorization: TOKEN_MEYO_API,
            'Content-Type': 'application/json'
        };
    }

    if (uid === MEFOOD_TOKEN) {

        return {
            Authorization: `Bearer ${MEFOOD_TOKEN}`,
            'Content-Type': 'application/json'
        };
    }

    // Try sessionStorage first
    let token = sessionStorage.getItem(`token-${uid}`);

    // If not found or expired, request new token
    if (!token || token === 'undefined') {
        token = await fetchFirebaseToken(uid);
    }

    return {
        Authorization: token,
        'Content-Type': 'application/json'
    };
}

function createRequest(method: Method, uid?: string) {
    return async (url: string, data: any = null, config?: AxiosRequestConfig) => {
        try {
            const headers = await getHeaders(uid);
            return await axiosInstance.request({
                method,
                url,
                data,
                ...config,
                // Mezclar: un config.headers no debe borrar Authorization
                headers: { ...headers, ...(config?.headers as Record<string, string> | undefined) }
            });
        } catch (error) {
            throw error;
        }
    };
}

const axiosInstance = axios.create({
    timeout: API_TIMEOUT,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
        'Content-Type': 'application/json'
    }
});

export const requestSE = (uid?: string) => ({
    get: createRequest('get', uid),
    post: createRequest('post', uid),
    delete: createRequest('delete', uid),
    patch: createRequest('patch', uid)
});

function createExternalRequest(method: Method) {
    return async (url: string, data: any = null, config?: AxiosRequestConfig) => {
        try {
            return await axiosInstance.request({
                method,
                url,
                data,
                headers: { 'Content-Type': 'application/json' },
                ...config
            });
        } catch (error) {
            throw error;
        }
    };
}

export const externalRequestSE = () => ({
    get: createExternalRequest('get'),
    post: createExternalRequest('post'),
    delete: createExternalRequest('delete'),
    patch: createExternalRequest('patch')
});